import { KitBadge } from 'components/common/cms-kit';

const DefaultModule = (props) => {
  const { fields: _fields, properties, contentID: _contentID } = props.module;
  //console.log('DefaultModule', props);
  return (
    <div>
      {process.env.environment === 'development' && (
        <>
          <KitBadge>{properties.definitionName}</KitBadge> is not defined!
        </>
      )}
    </div>
  );
};

export default DefaultModule;
